import { render, staticRenderFns } from "./BidWinRateColumn.vue?vue&type=template&id=1d038f1f"
import script from "./BidWinRateColumn.vue?vue&type=script&lang=js"
export * from "./BidWinRateColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports